import {AfterViewInit, Component, OnDestroy} from '@angular/core';
import {AppService} from '../../services/app.service';

@Component({
  selector: 'pm-checkout',
  templateUrl: './checkout.component.html',
  styleUrls: ['./checkout.component.scss']
})
export class CheckoutComponent implements AfterViewInit, OnDestroy {

  constructor(
    private app: AppService
  ) {
    app.setTitle('Checkout');
    document.body.classList.add('categories-page');
  }

  ngAfterViewInit(): void {
    $('.myaccordion .brand-header,.refine-sec-top .refine-sec-top').click((e) => {
      $(e.target).siblings().slideToggle();
      $('.myaccordion,.refine-sec-top').toggleClass('active');
    });
    $('.refine-sec-top .brand-header-top').click((e) => {
      $(e.target).siblings().slideToggle();
      $('.refine-sec-top').toggleClass('active');
    });
    // ==================================== Select DropDown Js ====================================
    $(document).ready(() => {
      $('select').niceSelect();
    });

    // trim polyfill : https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim
    if (!String.prototype.trim) {
      // tslint:disable-next-line:only-arrow-functions typedef
      (function() {
        // Make sure we trim BOM and NBSP
        const rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
        // tslint:disable-next-line:typedef
        String.prototype.trim = function() {
          return this.replace(rtrim, '');
        };
      })();
    }

    [].slice.call(document.querySelectorAll('input,textarea.input__field')).forEach((inputEl) => {
      // in case the input is already filled..
      if (inputEl.value.trim() !== '') {
        classie.add(inputEl.parentNode, 'input--filled');
      }

      // events:
      inputEl.addEventListener('focus', onInputFocus);
      inputEl.addEventListener('blur', onInputBlur);
    });

    function onInputFocus(ev): void {
      classie.add(ev.target.parentNode, 'input--filled');
    }

    function onInputBlur(ev): void {
      if (ev.target.value.trim() === '') {
        classie.remove(ev.target.parentNode, 'input--filled');
      }
    }
  }

  ngOnDestroy(): void {
    document.body.classList.remove('categories-page');
  }
}
